var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_227_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9421 3.90441C26.8662 4.38114 25.7105 4.70325 24.4954 4.84885C25.7491 4.0987 26.687 2.91805 27.1342 1.52721C25.9564 2.22683 24.6673 2.71928 23.3229 2.98316C22.4189 2.01794 21.2216 1.37817 19.9167 1.16319C18.6118 0.948206 17.2725 1.17004 16.1066 1.79425C14.9407 2.41845 14.0136 3.41011 13.469 4.61525C12.9245 5.8204 12.7931 7.17161 13.0952 8.4591C10.7086 8.33927 8.37381 7.71894 6.24245 6.63839C4.11108 5.55783 2.23074 4.04119 0.723449 2.1869C0.208067 3.07593 -0.0882779 4.1067 -0.0882779 5.20446C-0.0888529 6.1927 0.154509 7.1658 0.620216 8.03743C1.08592 8.90905 1.75957 9.65226 2.5814 10.2011C1.6283 10.1708 0.696228 9.91323 -0.137239 9.44992V9.52723C-0.137335 10.9133 0.342108 12.2567 1.21974 13.3295C2.09737 14.4022 3.31913 15.1384 4.67772 15.4129C3.79356 15.6522 2.86658 15.6874 1.96681 15.516C2.35012 16.7086 3.09678 17.7515 4.10225 18.4986C5.10772 19.2458 6.32168 19.6599 7.57416 19.6828C5.448 21.3519 2.8222 22.2573 0.119163 22.2533C-0.359651 22.2534 -0.83806 22.2255 -1.3136 22.1695C1.43014 23.9337 4.62404 24.8699 7.88597 24.8663C18.928 24.8663 24.9644 15.7208 24.9644 7.7891C24.9644 7.53141 24.958 7.27114 24.9464 7.01345C26.1206 6.16433 27.1341 5.11285 27.9395 3.90827L27.9421 3.90441V3.90441Z",
    fill: "#ff2b06"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ce0762d88fa163f76a2d0b0a42e71232.svg";
export { ForwardRef as ReactComponent };